import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { Operator } from '@games/core/operator';
import { GamesSharedModule } from '@games/games-shared/games-shared.module';
import { OrchestratorStage, provideDynamicOrchestrator } from '@games/shared/orchestrator';
import { GameButtonComponent } from '@new-core/components/buttons-game/game-button/game-button.component';
import { TranslateModule } from '@ngx-translate/core';
import { MathResultContainerOrchestrator } from './math-result-container-orchestrator';

@Component({
    selector: 'ms-math-result-container',
    imports: [CommonModule, TranslateModule, GameButtonComponent, GamesSharedModule],
    templateUrl: './math-result-container.component.html',
    styleUrls: ['./math-result-container.component.scss'],
    providers: [provideDynamicOrchestrator(MathResultContainerOrchestrator)],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MathResultContainerComponent {
  @Input() isCorrect: boolean;

  @Input() operator: Operator;

  @Input() canStart: boolean = true;

  @Input() canStop: boolean = true;

  @Input() phrase: string = '';

  @Output('stop') stopEventEmitter = new EventEmitter();

  @Output('play') playEventEmitter = new EventEmitter();

  public get orchestratorStage(): OrchestratorStage<MathResultContainerOrchestrator> {
    return 'results';
  }

  stop() {
    this.stopEventEmitter.emit();
  }

  play() {
    this.playEventEmitter.emit();
  }
}
